module.exports = __webpack_public_path__ + "5_Alerts_withoutNavHeader-a95bdcc6d860752f98dfa58303a58f39.jpg";